import { colors } from '#Theme';
const { dark } = colors;

export function setCanvasDimensions(canvas, w, h) {
    canvas.style.width = `${w}px`;
    canvas.width = w;
    canvas.style.height = `${h}px`;
    canvas.height = h;
}

export function draw(canvas, bg, index, w0, h0) {
    // w0, h0 refer to option starting position of where to take rectangle from source image
    let c = canvas.getContext('2d');
    let { width: w, height: h } = canvas;
    //flip for additional variance between bg images on even and odd 
    if (index % 2 === 0) {
        c.translate(w, 0); 
        c.scale(-1, 1); 
    }
    //get proper scaling, if no w0, h0 given, start @ 1 to get a random w0, and h0, then calculate scale
    let s;
    if (!(w0 >= 0)) {
        w0 = Math.floor(Math.random() * (bg.width - w));
        h0 = Math.floor(Math.random() * (bg.height - h));
        // console.log({w0, h0})
    }
    s = scale(bg.width, bg.height, w, h, w0, h0)
    // console.log(w0, h0)
    c.drawImage(bg, w0, h0, w * s, h * s,
        0, 0, w, h);
    //flip back so gradient is drawn correctly
    if (index % 2 === 0) {
        c.scale(-1, 1);
        c.translate(-w, 0);
    }
    const pattern = c.createLinearGradient(0, 0, w, 0);
    pattern.addColorStop(0.2, dark);
    pattern.addColorStop(0.6, 'transparent');
    c.fillStyle = pattern;
    c.fillRect(0, 0, w, h); 
}


function scale(bgW, bgH, destW, destH, w0, h0) {
    let s1 = (bgW - w0) / destW; 
    let s2 = (bgH - h0) / destH; 
    return Math.min(s1, s2, 2.5)
}